<div class="nav-bar disable-select" [ngClass]="{'on-home': isHomePage && !isMobile }">
  <!-- mobile -->
  <div class="mobile-nav">
    <button mat-icon-button class="back-to-menu-button" (click)="returnToMenu()" *ngIf="isCheckoutPage">
      <mat-icon>menu_book</mat-icon>
    </button>

    <div class="logo" *ngIf="tenant.Branding.LogoImageUrl">
      <a style="display: flex; align-items: center;" (click)="navigateHome($event)" href="{{ this.navigatorService.generateHomePath() }}">
        <img style="max-width: 100%" [src]="tenant.Branding.LogoImageUrl" draggable="false" id="brandLogo">
      </a>
    </div>

    <div class="feedback">
      <button mat-icon-button (click)="feedback(feedbackModalContent)">
        <span class="material-symbols-outlined">feedback</span>
      </button>
    </div>
    <ng-container *ngTemplateOutlet="userContainer"></ng-container>
  </div>

  <!-- desktop -->
  <div class="desktop-nav">
    <div class="desktop-nav-logo-wrapper" *ngIf="tenant.Branding.LogoImageUrl">
      <a class="desktop-nav-logo disable-select" (click)="navigateHome($event)" href="/">
        <img class="desktop-nav-logo-image" [src]="tenant.Branding.LogoImageUrl" draggable="false" id="logImage">
      </a>
    </div>

    <div class="desktop-nav-details">
      @if (shouldShowSite()) {
        <div class="desktop-nav-details-sitename">
          <div class="sitename text-info-label">
            <div>You are ordering from</div>
            <div class="sitename-current">{{ currentSite.Name }}</div>
            <div class="nav-cards-tool-tip" (click)="confirmChangeStore(switchStoreModal)">
              <div class="nav-cards-tool-tip-text">
                <mat-icon>sync_alt</mat-icon>
                Change Restaurant
              </div>
            </div>
          </div>
        </div>
      }

      <div class="desktop-nav-details-container">
        <div class="desktop-nav-details-usermenu" [ngClass]="{'menu-left': !shouldShowBasket()}">
          @if (currentUser) {
            <div>
              <button mat-icon-button (click)="feedback(feedbackModalContent)">
                <span class="material-symbols-outlined">feedback</span>
              </button>
            </div>
          } @else {
            <div>
              <a class="button-action-2" (click)="feedback(feedbackModalContent)" tabindex="0">
                Feedback
              </a>
            </div>
          }
          <ng-container *ngTemplateOutlet="userContainer"></ng-container>
        </div>

        <div class="nav-details-basket" *ngIf="shouldShowBasket()" (click)="openBasket()">
          <span class="text-info-label cart-label">Cart</span>
          <mat-icon (click)="toggleBasket()">shopping_cart</mat-icon>
          <div class="cart-total-label" [@valueAnimation]="currentBasketCount">{{ currentBasketCount }}</div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #userContainer>
  <div class="user-dropdown">
    @if (currentUser) {
      <button class="user-dropdown-button" mat-icon-button [mat-menu-trigger-for]="userDetailsMenu">
        <span class="material-symbols-outlined"> account_circle </span>
      </button>
    
      <mat-menu classList="user-menu-dropdown" #userDetailsMenu="matMenu">
        <mat-nav-list class="user-menu-dropdown-list" style="padding-top: 0;">
          <a mat-list-item [routerLink]="['/profile']" [queryParams]="{view: 'account'}" *ngIf="!isProfilePage">
            <div class="flex-row no-wrap user-menu-dropdown-list-inner-container">
              <mat-icon class="mobile-menu-list icon text-color-branded">person</mat-icon>
              <p class="dropdown-Item-p">My Profile</p>
            </div>
          </a>
    
          <a mat-list-item [routerLink]="['/profile']" [queryParams]="{view: 'orders'}" *ngIf="!isProfilePage">
            <div class="flex-row no-wrap user-menu-dropdown-list-inner-container">
              <mat-icon class="mobile-menu-list icon text-color-branded">shopping_bag</mat-icon>
              <p class="dropdown-Item-p">My Orders</p>
            </div>
          </a>
    
          <a mat-list-item [routerLink]="['/profile']" [queryParams]="{view: 'loyalty'}" *ngIf="!isProfilePage && !tenant.SuppressLoyalty">
            <div class="flex-row no-wrap user-menu-dropdown-list-inner-container">
              <mat-icon class="mobile-menu-list icon text-color-branded">info</mat-icon>
              <p class="dropdown-Item-p">Loyalty Info</p>
            </div>
          </a>
    
          <a mat-list-item (click)="returnToMenu()" *ngIf="currentBasket && !isMenuPage">
            <div class="flex-row no-wrap user-menu-dropdown-list-inner-container">
              <mat-icon class="mobile-menu-list icon text-color-branded">restaurant</mat-icon>
              <p class="dropdown-Item-p">Menu</p>
            </div>
          </a>
    
          <a mat-list-item (click)="switchPaymentProvider()" *ngIf="isCheckoutPage && showProviderSwapButton">
            <div class="flex-row no-wrap user-menu-dropdown-list-inner-container">
              <mat-icon class="mobile-menu-list icon text-color-branded">swap_horiz</mat-icon>
              <p class="dropdown-Item-p">Switch to {{ paymentProviderInverse }}</p>
            </div>
          </a>
    
          <a mat-list-item (click)="logOut()">
            <div class="flex-row no-wrap user-menu-dropdown-list-inner-container">
              <mat-icon class="mobile-menu-list icon text-color-branded">logout</mat-icon>
              <p class="dropdown-Item-p">Logout</p>
            </div>
          </a>
        </mat-nav-list>
      </mat-menu>
    } @else {
      @if (isTablet) {
        <button mat-icon-button (click)="login()">
          <span class="login-button material-symbols-outlined">
            person
          </span>
        </button>
      } @else {
        <div class="sign_btn" style="margin: 0 10px">
          <a class="button-action-1" (click)="login()" tabindex="0">
            Sign In / Register
          </a>
        </div>
      }
    }
  </div>
</ng-template>

<ng-template #basketModalContent>
  <basket-component [showCheckout]="true"
                    style="height: 100%"
                    (allDone)="toggleBasket()"></basket-component>
</ng-template>

<ng-template #switchStoreModal>
  <div class="modal-header nav disable-select">
    <h4 class="modal-title nav">Warning</h4>

    <mat-icon (click)="closeModalById('confirmSwitchStore')">close</mat-icon>
  </div>

  <div class="modal-body nav disable-select">
    <p> You've currently got items in your basket. Please be aware that these items are tied to this store.</p>
  </div>

  <div class="modal-footer nav disable-select">
    <button type="button" class="modal-button-light nav button-action-2" (click)="closeModalById('confirmSwitchStore')">Cancel</button>
    <button type="button" class="modal-button-light nav button-action-1" (click)="switchStore()">Change</button>
  </div>
</ng-template>

<ng-template #feedbackModalContent>
  <feedback-component [userId]="currentUser?.Id" (close)="closeModalById('feedbackForm')"></feedback-component>
</ng-template>
